import {
  DocumentNode,
  OperationVariables,
  QueryHookOptions,
  TypedDocumentNode,
  useQuery,
} from "@apollo/client";

import { parseErrors } from "../graphql";
import { useSnackbarMessage } from "./useSnackbarMessage";

function useSnackbarQuery<T = any>(
  query: DocumentNode | TypedDocumentNode<any, OperationVariables>,
  options: QueryHookOptions<any, OperationVariables> = {}
) {
  const { raiseErrorSnackbar } = useSnackbarMessage();

  return useQuery<T>(query, {
    onError: (e) => {
      raiseErrorSnackbar(parseErrors(e));
    },
    ...options,
  });
}

export { useSnackbarQuery };
